module.exports = __webpack_public_path__ + "static/media/watermark.ad99fb49.png";